import * as React from "react";
import { BsChevronRight } from "react-icons/bs";
import { connect } from "common/connect";
import EventHelper from "common/helpers/eventHelper/eventHelper";
import StoreKeys from "common/storeKeys";
import { openLiveEvent, useOtherLiveEvent } from "./liveEventPair";
import "./LiveEventHero.scss";

const propKeys = {
	eventData: StoreKeys.EVENT.EVENTDATA,
	live: StoreKeys.EVENT.LIVE,
};

function LiveEventHeroC({ eventData, live }) {
	const pair = useOtherLiveEvent(eventData, live);
	if (!pair) {
		return <></>;
	}

	const { other, onMain, picksHelper } = pair;

	return (
		<div className="live-event-hero" onClick={() => openLiveEvent(other)}>
			<div
				className="live-event-hero-bg"
				style={{
					backgroundImage: `url("${EventHelper.getEventImageUrl(other)}")`,
				}}
			/>
			<div className="live-event-hero-text">
				<h4>{other.nameOverride ?? other.name}</h4>
				<label>
					{onMain ? (
						<>
							Picks open
							<span className="sep" />
							locks in {picksHelper.getTimeTillLock()}
						</>
					) : (
						"Live now"
					)}
				</label>
			</div>
			<span className="live-event-hero-go">
				<BsChevronRight />
			</span>
		</div>
	);
}

export default function LiveEventHero(props) {
	return connect(<LiveEventHeroC />, propKeys, props);
}
